import React from "react"
import Section from "@components/section"
import Button from "@components/button"
import Title from "@components/title"
import styles from "./plane.module.scss"

import planeImage from "@images/map.png"
import planeWithBgImage from "@images/map-with-bg.jpg"

const Plane = React.memo(props => {
  return (
    <Section>
      <Section.Inner>
        <Title
          sub={
            <>
              今年的核聚变现场，你不仅可以参与各种游戏挑战，还可以参与全新的项目：大型线上+线下实景互动游戏玩法，我们起名为「弧光行动」
              <br />
              使用「弧光行动」游戏小程序，不仅可以根据故事包剧情完成线上游戏任务、还能进行线下的实景探索，
              <br />
              其中有解谜的脑力考验，也有线下调查的观察力比拼，既可以组队也可以独自勇敢前行。
            </>
          }
        >
          全新玩法
          <br />
          线下实景互动冒险游戏
        </Title>
        <Section.Inner>
          <Button className={styles.map} href={planeWithBgImage}>
            <img className="fluidImg" src={planeImage} alt="场地图" />
          </Button>
        </Section.Inner>
      </Section.Inner>
    </Section>
  )
})

Plane.displayName = "Plane"
export default Plane
